<template>
  <div>
    <!-- 新闻 -->
    <div class="dif alc news">
      <!--左侧-->
      <div class="left posr" style="width: 30rem;height: 32rem;" @click="goDetail(yaowen[0].id)">
        <img class="bgcb pointer w100 h100" :src="$store.state.url + yaowen[0].image" v-if="yaowen.length>0">
        <div class="fs16 col101010 mrTop10 pointer two_overflow left_text">{{yaowen[0].title || ''}}</div>
      </div>
      <!--右侧-->
      <div class="right">
        <!--右侧分类-->
        <div class="dif right_tabs">
          <div class="tab pointer" style="margin-right: 7.5rem;" @click="setTabs(1)" :class="{'active': current===1}">要闻快递</div>
          <div class="tab pointer" @click="setTabs(2)" :class="{'active': current===2}">热点查询</div>
        </div>
        <!--右侧列表-->
        <ul style="margin-top: 1.7rem;">
          <li class="one_overflow list col101010 fs14 mrBtm10 pointer right_item" @click="goDetail(item.id)"
              v-for="(item,index) in yaowen" :key="index+'1'" v-if="index<8" v-show="current===1">· {{item.title}}</li>
          <li class="one_overflow list col101010 fs14 mrBtm10 pointer right_item" @click="goDetail(item.id)"
              v-for="(item,index) in hot" :key="index+'2'" v-if="index<8" v-show="current===2">· {{item.title}}</li>
        </ul>
      </div>
    </div>
    <!--报考专业-->
    <div class="baokao">
      <!--选择-->
      <div class="dif alc" style="margin-bottom: 4.2rem;">
        <div class="difcac select pointer" @click="showSelect=true">
          <!--显示选择的专业-->
          <div v-if="xuekeName" class="one_overflow">
            <span>{{xuekeName}}</span>
            <span v-if="zhuanyeName">-{{zhuanyeName}}</span>
          </div>
          <div v-else>请选择报考专业</div>
        </div>
        <div class="fs14 col101010 select_border">
          <span class="mrRit20">根据您的选择：当前学历：{{xueli || '请选择'}}</span>
          <span class="mrRit20">您想报考学历：{{xueliName || '请选择'}}</span>
          <span>报考专业：{{xuekeName}}</span>
          <span v-if="zhuanyeName">- - {{zhuanyeName}}</span>
          <span class="mrLft20">可报考学院为：</span>
        </div>
      </div>
      <!--可选择列表-->
      <div class="scoll dif alc">
        <!--列表-->
        <div class="item" v-for="(item,index) in school" :key="index">
          <!--图片-->
          <img class="bgcb w100" style="height: 19.2rem;width: 32rem;" :src="$store.state.url+item.image">
          <div class="fs18 col101010 mrTop10 mrBtm10 bold one_overflow">{{item.name}}</div>
          <!--剩余名额-->
          <div style="height: 6rem;overflow: hidden">
            <div class="col101010 fs14">高起专（剩余名额：{{item.num}}人）</div>
            <div class="col101010 fs14">高起本（剩余名额：{{item.numb}}人）</div>
            <div class="col101010 fs14">专升本（剩余名额：{{item.numz}}人）</div>
          </div>
          <div class="difb alc w100">
            <div class="button2 difcac colfff" @click="showToast()" v-if="item.num<=0 && applyXueli==1">已招满</div>
            <div class="button2 difcac colfff" @click="showToast()" v-else-if="item.numb<=0 && applyXueli==2">已招满</div>
            <div class="button2 difcac colfff" @click="showToast()" v-else-if="item.numz<=0 && applyXueli==3">已招满</div>
            <div class="button1 difcac colfff" style="background: #e24537" @click="goSignUp()" v-else>选择报名</div>
            <div class="button1 difcac colfff" @click="goSchool(item.id)">查看简介</div>
          </div>
        </div>
        <!--空-->
        <div v-if="school.length<=0" class="w100">
          <div class="fs22 col666 h100 w100 difc">
            <div>暂无可报考学院</div>
          </div>
        </div>
      </div>
    </div>
    <!--下方公告 动态-->
    <div class="down dif alc pdBtm20" style="margin-top: 9rem;">
      <!--公告-->
      <div style="width: 37%;padding-right: 7rem;height: 31.7rem;" class="box">
        <div class="down_title difcac">通知公告</div>
        <ul class="mrTop20 w100">
          <li class="one_overflow fs14 col101010 mrBtm10 list pointer" @click="goDetail(item.id)"
              v-for="(item,index) in notice" v-if="index<8" :key="index+'3'">· {{item.title}}</li>
        </ul>
      </div>
      <!--公告-->
      <div style="width: 37%;padding-right: 7rem;height: 31.7rem;" class="box">
        <div class="down_title difcac">招考动态</div>
        <ul class="mrTop20">
          <li class="one_overflow fs14 col101010 mrBtm10 list pointer" @click="goDetail(item.id)"
              v-for="(item,index) in zhaokao" v-if="index<8" :key="index+'4'">· {{item.title}}</li>
        </ul>
      </div>
      <!--二维码-->
      <div style="" class="box">
        <div class="difb alc">
          <div class="difcc">
            <img class="bgcb" style="width: 12rem;height: 12rem;" :src="$store.state.url+wx1">
            <div class="mrTop10 col101010 fs14">官方微信1</div>
          </div>
          <div class="difcc">
            <img class="bgcb" style="width: 12rem;height: 12rem;" :src="$store.state.url+wx2">
            <div class="mrTop10 col101010 fs14">官方微信2</div>
          </div>
        </div>
        <!--广告图-->
        <div class="adv_img mrTop20 difcac colfff">
          <img :src="$store.state.url+gg" class="h100">
        </div>
      </div>
    </div>
    <!--专业查询-->
    <div v-show="showSelect" class="mb">
      <div class="search_warp">
        <!--关闭按钮-->
        <div class="close pointer" @click="showSelect=false">
          <i class="el-icon-close" style="font-size: 2.6rem;"></i>
        </div>
        <div class="tc bold col101010 fs24 tc">查询学校</div>
        <!--最高学历-->
        <div class="tlt" style="margin-top: 3.6rem;">
          <div class="fs16 col101010"><span style="color: #EE2352">*</span>最高学历</div>
          <div class="w100" style="margin-top: 2rem;">
            <el-select placeholder="请选择您的最高学历" class="w100" v-model="xueli">
              <el-option
                  v-for="item in nowXueliArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!--报考方式-->
        <div class="tlt" style="margin-top: 2.5rem;">
          <div class="fs16 col101010"><span style="color: #EE2352">*</span>报考学历</div>
          <div class="w100" style="margin-top: 2rem;">
            <el-select placeholder="请选择您的报考学历" class="w100" v-model="applyXueli">
              <el-option
                  v-for="item in applyXueliArr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <!--报考专业-->
        <div class="tlt" style="margin-top: 2.5rem;">
          <div class="fs16 col101010"><span style="color: #EE2352">*</span>报考专业</div>
          <div class="w100 posr" style="margin-top: 2rem;">
            <el-cascader style="width: 100%;" ref="cascader"
                :props="props" v-model="zhuanye" :options="applyXuekeArr"></el-cascader>
          </div>
        </div>
        <!--立即查询-->
        <div class="now difcac colfff fs18 pointer" @click="search()">立即查询</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      current: 1,//当前选择的右侧tab
      showSelect: false,//显示查询学校
      //文章
      yaowen: [{
        id: '',
        title: '',
        image: '',
      }],//要闻 71
      hot: [],//热点 72
      notice: [],//通知公告 73
      zhaokao: [],//招考动态 74
      //微信 和 广告
      wx1: '',
      wx2: '',
      gg: '',
      school: [],//学校列表


      nowXueliArr: [ //当前学历
        {value: '小学',label: '小学'},
        {value: '初中',label: '初中'},
        {value: '高中',label: '高中'},
        {value: '专科',label: '专科'},
        // {value: '本科',label: '本科'},
      ],
      applyXueliArr: [ //报考学历
        {value: 1,label: '高起专',disabled: false,},
        {value: 2,label: '高起本',disabled: false,},
        {value: 3,label: '专升本',disabled: true,},
      ],
      applyXuekeArr: [ //报考学科

      ],
      applyZhuanyeArr: [],//报考专业数组
      xueli: '',//当前学历
      applyXueli: '',//报考学历
      zhuanye: '',//报考专业
      xueliName: '',
      xuekeName: '',
      zhuanyeName: '',
      props: {
        lazy: true,
        label: 'name',
        value: 'id',
        lazyLoad: (node,resolve)=> {
          this.$axios("POST","/index/zhuanye_list",{xk_id:node.data.id})
          .then(res => {
            if(res.code===1) {
              console.log(res.data);
              for(let i in res.data) {
                res.data[i].leaf = true
              }
              this.applyZhuanyeArr = res.data
              resolve(res.data)
            }
          })
        }
      }
    }
  },
  watch: {
    xueli(newValue) { //选择最高学历
      //根据选择的最高学历，对应可报考学历
      if(newValue==='专科') {
        this.applyXueliArr[0].disabled = true
        this.applyXueliArr[1].disabled = true
        this.applyXueliArr[2].disabled = false
        this.applyXueli = 3
      }else {
        this.applyXueliArr[0].disabled = false
        this.applyXueliArr[1].disabled = false
        this.applyXueliArr[2].disabled = true
        this.applyXueli = 1
      }
    },
    applyXueli(newValue) { //选择学历获取学科
      this.getXueKe(newValue)
    },
  },
  methods: {
    showToast() { //学校已满提示
      this.$alert('该学校已招满',{type: 'error'})
    },
    isLogin() { //判断是否登陆
      console.log(this.$store.state.userinfo);
      if(!this.$store.state.userinfo) {
        return false
      }
      return true
    },
    search() {//立即查询
      this.showSelect = false
      let arr = this.zhuanye
      let zhuanyeId = arr[1]
      let xuekeId = arr[0]
      console.log(this.applyZhuanyeArr,'获取的专业学历');
      console.log(zhuanyeId);
      for(let i in this.applyXueliArr) {
        if(this.applyXueliArr[i].value=== this.applyXueli) this.xueliName = this.applyXueliArr[i].label
      }
      for(let i in this.applyXuekeArr) {
        if(this.applyXuekeArr[i].id=== xuekeId) this.xuekeName = this.applyXuekeArr[i].name
      }
      //获取选择的子节点的label
      if(this.$refs.cascader.getCheckedNodes()[0].level==2){
        this.zhuanyeName = this.$refs.cascader.getCheckedNodes()[0].label;
      }else {
        this.zhuanyeName = ''
      }
      console.log(this.$refs.cascader.getCheckedNodes());
      this.getSchoolList(zhuanyeId)
    },
    getXueKe(pname) { //获取学科
      this.$axios("POST","/index/xk_list",{pname},'加载中')
          .then(res => {
            if(res.code===1) {
              this.applyXuekeArr = res.data
            }
          })
    },
    goSignUp() { //报名
      let isLogin = this.isLogin()
      if(!isLogin) {
        return this.$alert('请登录后操作').then(res => this.$emit('showRegister',{}))
      }
      this.$router.push('/infoCenter/sign').catch(err => err)
    },
    setTabs(i) { //切换右侧tab
      this.current = i
    },
    goDetail(id) { //文章详情
      let isLogin = this.isLogin()
      if(!isLogin) {
        return this.$alert('请登录后操作').then(res => this.$emit('showRegister',{}))
      }
      let routeUrl = this.$router.resolve({
        path: '/article',
        query: {id: id}
      })
      window.open(routeUrl .href, '_blank');
    },
    goSchool(id) { //查看学校
      let isLogin = this.isLogin()
      if(!isLogin) {
        return this.$alert('请登录后操作').then(res => this.$emit('showRegister',{}))
      }
      let routeUrl = this.$router.resolve({
        path: '/school',
        query: {
          id: id
        }
      })
      window.open(routeUrl .href, '_blank');
    },
    //获取下方微信广告图
    getSystem() {
      this.$axios("POST","/index/cms_system",{})
      .then(res => {
        if(res.code===1) {
          this.gg = res.data.gg
          this.wx1 = res.data.wx1
          this.wx2 = res.data.wx2
        }else {
          this.$alert(res.msg)
        }
      })
    },
    //获取首页要闻
    getArchives71() {
      this.$axios("POST","/index/cms_archives",{id: 71})
      .then(res => {
        if(res.code===1) {
          this.yaowen = res.data
        }
      })
    },
    //获取首页热点
    getArchives72() {
      this.$axios("POST","/index/cms_archives",{id: 72})
      .then(res => {
        if(res.code===1) {
          this.hot = res.data
        }
      })
    },
    //获取首页通告
    getArchives73() {
      this.$axios("POST","/index/cms_archives",{id: 73})
          .then(res => {
            if(res.code===1) {
              this.notice = res.data
            }
          })
    },
    //获取招考动态
    getArchives74() {
      this.$axios("POST","/index/cms_archives",{id: 74})
          .then(res => {
            if(res.code===1) {
              this.zhaokao = res.data
            }
          })
    },
    getSchoolList(pname) { //获取首页学校列表
      this.$axios("POST","/index/school",{pname})
      .then(res => {
        if(res.code===1) {
          this.school = res.data
        }
      })
    },
  },
  created() {
    if(this.$route.query.pid) {
      localStorage.setItem('jiaoyupid',this.$route.query.pid)
    }
    if(!JSON.parse(localStorage.getItem('jiaoyu'))) {
      this.showSelect = true
    }
    this.getSystem() //获取下方微信广告图
    this.getArchives71()
    this.getArchives72()
    this.getArchives73()
    this.getArchives74()
    // this.getSchoolList()
  }
}
</script>

<style scoped>
  .left{
     width: 30rem;
   }
  .right{
    margin-left: 7rem;
    height: 37rem;
    width: 60%;
  }
  .right_tabs{
    border-bottom: 1px solid #07838D;
    padding-bottom: 0.8rem;
  }
  .right_item{
    padding: 0.5rem 0;
  }
  .tab{
    font-size: 2rem;
    color: #888;
  }
  .tab.active{
    color: #333;
    position: relative;
  }
  .tab.active:before{
    content: '';
    display: block;
    width: 100%;
    height: 0.2rem;
    background: #06676F;
    position: absolute;
    bottom: -0.8rem;
    left: 0;
  }
  .list{
    transition: all 0.1s;
  }
  .list:hover{
    text-decoration: underline;
    color: #e17835;
  }
  .news{
    width: 100%;
    padding-bottom: 3.8rem;
    margin-bottom: 3.8rem;
    border-bottom: 2px solid #07838D;
  }
  .select{
    width: 18.4rem;
    height: 3.2rem;
    border: 1px solid #07838D;
    margin-right: 2.8rem;
    color: #aaa;
    font-size: 1.4rem;
    cursor: pointer;
  }
  .scoll{
    width: 100%;
    overflow-x: auto;
    padding-bottom: 1.5rem;
  }
  .item{
    width: 32rem;
    margin-right: 5rem;
  }
  .item:nth-last-child(1) {
    margin-right: 0;
  }
  .button1{
    width: 12.4rem;
    height: 4.1rem;
    background: #4eac4e;
    font-size: 1.4rem;
    box-sizing: border-box;
    cursor: pointer;
  }
  .button2{
    width: 12.4rem;
    height: 4.1rem;
    background: #929393;
    font-size: 1.4rem;
    box-sizing: border-box;
    cursor: pointer;
  }
  .down_title{
    width: 10rem;
    margin: 1.5rem 0;
    height: 2.3rem;
    color: #333;
    font-size: 1.8rem;
    border-left: 3px solid #07838D;
  }
  .adv_img{
    width: 28.8rem;
    height: 8.7rem;
    background: #07838D;
    color: #FFFFFF;
    font-size: 1.6rem;
  }
  .mb{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .search_warp{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 50rem;
    border-radius: 2rem;
    background: #FFFFFF;
    text-align: center;
    box-shadow: 0px 0px 4rem 0px rgba(0, 0, 0, 0.4);
    box-sizing: border-box;
    padding: 3rem;
  }
  .close{
    position: absolute;
    top: 3rem;
    right: 3rem;
  }
  .now{
    width: 100%;
    margin-top: 3.6rem;
    height: 4rem;
    border-radius: 0.5rem;
    background: #4eac4e;
  }
  .left_text{
    color: #FFFFFF;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 7rem;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding: 0.5rem;
    padding-bottom: 1rem;
    /*background: rgba(0,0,0,0.5);*/
    background: linear-gradient(to bottom, rgba(0,0,0,0.0),rgba(0,0,0,0.5));
  }
  .select_border{
    border-left: 1px solid #07838D;
    padding-left: 2rem;
  }
</style>